import { useMemo } from 'react';
import LinearItemWrap from '@/components/LinearItemWrap';
import VersionLabel from '@/pages/product/components/VersionWrapper/components/VersionLabel';
import { getVersionName } from '@/pages/product/config/ProductVersion.config';
import { ProductTracker } from '@/utils/Tracker';
import ComponentsErrorBoundary from '@/components/ErrorBoundary/ComponentsErrorBoundary';
import styles from './CommodityItem.module.less';
import MobxWrap from '@/components/MobxWrap';
import { LabelType } from '@/types/tag';
import { Commodity } from '@/types/product';
import classNames from 'classnames';

type Props = {
  onChangeCommodity: (cid: number) => void;
  labels: LabelType[];
  commodity: Commodity;
  className?: string;
};

/**
 * 套餐单个选项item
 * eg: https://res.insta360.com/static/677d507ef9dfd2f70ded7ee9ef59d27a/item.jpg
 * @param {function} onChangeCommodity 点选后回调
 * @param {array} labels item右上角的标签
 * @param {object} commodity 套餐信息 / 规格则传入第一个套餐的信息
 * @param {string} className
 */
const NoDescCommodityItem = MobxWrap<Props, ['product', 'area', 'app']>(['product', 'area', 'app'], (props) => {
  const {
    labels,
    onChangeCommodity,
    commodity,
    commodity: { product: pid, id: cid },
    className,
    product: { curSelectCommodityId, isSelectPersonalized },
    area: {
      country: { X_Language },
    },
  } = props;

  // 当前item是否选中,根据curSelectCommodity自动判断
  const active = useMemo(
    () => !isSelectPersonalized && curSelectCommodityId === cid,
    [cid, curSelectCommodityId, isSelectPersonalized]
  );

  // 当前item是否无库存, 规格逻辑相同：如果连第一个套餐都无库存了，此规格肯定也🈚️了
  const isOutOfStock = useMemo(() => commodity.isOutOfStock, [commodity.isOutOfStock]);

  /** 选中套餐 */
  const handleClick = () => {
    onChangeCommodity(cid);
    ProductTracker.productPage({
      action: 'commodity_select',
      productState: props.product,
    });
  };

  if (!cid) return null;

  return (
    <div className={[styles.itemContainer, styles.noDescItem, className].join(' ')} id={'id' + pid + cid}>
      <div className={styles.labelWrap}>
        {labels?.map((label, k) => (
          <VersionLabel label={label} key={k} />
        ))}
      </div>
      <ComponentsErrorBoundary key={cid} name='CommodityItem LinearItemWrap' data={{ cid, active, commodity }}>
        <LinearItemWrap
          key={cid}
          onClick={handleClick}
          theme={isOutOfStock ? 'outOfStock' : 'productBlack'}
          active={active}
          className={classNames(styles.commodityItem, isOutOfStock && styles.disable)}
        >
          <div className={styles.itemWrap}>
            <div className={styles.nameWrap}>
              <div
                className={styles.name}
                dangerouslySetInnerHTML={{
                  __html: getVersionName({
                    cids: commodity.id,
                    X_Language,
                    commodityName: commodity.commodityName,
                  }),
                }}
              />
            </div>
          </div>
        </LinearItemWrap>
      </ComponentsErrorBoundary>
    </div>
  );
});

export default NoDescCommodityItem;
